import { useMarketingCampaignFormModelContext } from "../../../../../_shared/context";
import { useMarketingNewCampaignFormModelContext } from "../../../../context";

export const useSaveButton = () => {
	const { viewModel } = useMarketingCampaignFormModelContext();
	const { onSave } = useMarketingNewCampaignFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onSave,
	};
};
